document.addEventListener('DOMContentLoaded', function () {

    const searchIcon = document.querySelector('.search-toggle');
    const searchForm = document.querySelector('.wens-magazine-pro-search-form');

    searchIcon.addEventListener('click', function () {
        searchForm.classList.toggle('active');
    });

});